import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ConfirmModal from '../../../ConfirmModal';
import MarkdownToHtml from '../../../MarkdownToHtml';
import { TravelTypes } from '../../../../constants';
import formatTravelMode from '../../../../helpers/formatTravelMode';

const ChangeInfoModal = ({ onCancel, mode }) => {
  const { travelAgency } = useSelector((store) => store.user);
  let message = `Please contact ${travelAgency ? travelAgency.name : ''}'s air desk (see Help menu item at the top of this page) team for making changes trip.`;
  const tripConfirmationMessages = (travelAgency && travelAgency.settings
     && travelAgency.settings.tripConfirmationMessages) || {};

  if (mode === TravelTypes.hotel && tripConfirmationMessages.changeHotel) {
    message = tripConfirmationMessages.changeHotel;
  }
  if (mode === TravelTypes.flight && tripConfirmationMessages.changeFlight) {
    message = tripConfirmationMessages.changeFlight;
  }
  if (mode === TravelTypes.carrental && tripConfirmationMessages.changeCar) {
    message = tripConfirmationMessages.changeCar;
  }

  return (
    <ConfirmModal
      onCancel={onCancel}
      cancelButtonLabel="Close"
      event={`Trip confirmation - Change ${formatTravelMode(mode)} click (change not allowed)`}
      eventDetail={message}
      message={(
        <MarkdownToHtml
          content={message}
          className="text-black"
        />
      )}
    />
  );
};

ChangeInfoModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
};

export default ChangeInfoModal;
